import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import TheSidebar from '../TheSidebar/TheSidebar.vue';
import TheHeader from '../TheHeader/TheHeader.vue';
import TheFooter from '../TheFooter.vue';

export default defineComponent({
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
  },
  computed: {
    ...mapState(['isAuthenticated']),
  },
});
